// extracted by mini-css-extract-plugin
module.exports = {"content":"_1l32J","title":"_1sL42","subTitle":"UalOx","button":"_1fgpO"};